import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import eventTracker from "../../../utils/analytics";
import EVENT_NAMES from "../../../utils/eventNames";
const api_Url =
  process.env.NEXT_PUBLIC_API_URL || "https://api.itsonlyonestop.com";

export const loginThunk = createAsyncThunk(
  "signin",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      eventTracker.track(EVENT_NAMES.LOGIN_ATTEMPT, { email });

      const response = await axios.post(`${api_Url}/api/login`, {
        email,
        password,
        platform: "web",
      });

      eventTracker.track(EVENT_NAMES.LOGIN_SUCCESS, {
        userId: response?.data?.data?.user?.id,
        email: response?.data?.data?.user?.email,
      });

      return response?.data;
    } catch (error) {
      // console.log("error:", error);
      const errorMessage = error?.response?.data?.message || "Unknown error";
      eventTracker.track(EVENT_NAMES.LOGIN_FAILED, {
        email,
        error: errorMessage,
      });
      return rejectWithValue(error?.response?.data || "Unknown error");
    }
  }
);

export const signUpThunk = createAsyncThunk("signup", async (data) => {
  try {
    // Track Sign Up Attempt
    eventTracker.track(EVENT_NAMES.SIGNUP_ATTEMPT, {
      email: data.email,
      acquisitionChannel: data.acquisition_channel,
      referralCode: data.referral_code,
    });

    const response = await axios.post(`${api_Url}/api/signup`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    const user = response?.data?.data?.user;
    // Track Sign Up Success
    eventTracker.track(EVENT_NAMES.SIGNUP_SUCCESS, {
      userId: user?.id,
      email: user?.email,
      acquisitionChannel: data.acquisition_channel,
      referralCode: data.referral_code,
    });
    return response?.data;
  } catch (error) {
    // console.log(error);

    const errorData = error?.response?.data || {};
    const errorMessage = errorData?.message || "Unknown error";

    // Track Sign Up Failed
    eventTracker.track(EVENT_NAMES.SIGNUP_FAILED, {
      email: data.email,
      error: errorMessage,
      acquisitionChannel: data.acquisition_channel,
      referralCode: data.referral_code,
    });
    return error?.response?.data;
  }
});

export const forgetPasswordThunk = createAsyncThunk(
  "forget-password",
  async (data) => {
    try {
      eventTracker.track(EVENT_NAMES.FORGOT_PASSWORD_ATTEMPT, {
        email: data.email,
      });

      const response = await axios.post(`${api_Url}/api/forgot/password`, data);

      eventTracker.track(EVENT_NAMES.FORGOT_PASSWORD_SUCCESS, {
        email: data.email,
      });
      return response?.data;
    } catch (error) {
      const errorData = error?.response?.data || {};
      const errorMessage = errorData?.message || "Unknown error";
      // Track Forgot Password Failed
      eventTracker.track(EVENT_NAMES.FORGOT_PASSWORD_FAILED, {
        email: data.email,
        error: errorMessage,
      });

      return error?.response?.data;
    }
  }
);

export const checkValidationThunk = createAsyncThunk(
  "check-data",
  async (data) => {
    try {
      const response = await axios.post(
        `${api_Url}/api/vendor/check-data`,
        data
      );
      return response?.data;
    } catch (error) {
      // console.log(error);
      return error?.response?.data;
    }
  }
);
